module.exports = __webpack_public_path__ + "img/excel.0f29ff77.svg";